import React from "react";
//#region types
import { SalaryFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
import { AdvisorEnums } from "models/enums";
import { ACTION_SEPARATOR } from "models/propTypes/menuPropTypes";
//#endregion
//#region components
import { DashboardButtonGroup, FilterButton, PageLayouts, StyledButton } from "components/common";
import useGrossSalaryReportFilterDefinition from "./useGrossSalaryReportFilterDefinition";
import GrossSalaryListView from "./grossSalaryListView";
import SalarySpecificationListView from "../salarySpecification/listView";
import { Grid } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { useQueryStateEnum } from "routing/hooks";
import useSalaryPermissions from "../hooks/useSalaryPermissions";
//#endregion
import { DateHelper, EnumHelper, LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const GrossSalaryReport: React.FC = (props) => {
  const { filterFormFields, filterQueryStateHandler } = useGrossSalaryReportFilterDefinition();
  const { getIsGrossSalaryReportAvailable } = useSalaryPermissions();

  const location = useLocation();
  const navigate = useNavigate();

  const [reportType, setReportType] = useQueryStateEnum<AdvisorEnums.SalariesReport>(
    "reportType",
    AdvisorEnums.SalariesReport.GrossSalaries
  );

  const onReportTypeButtonClick = (type: AdvisorEnums.SalariesReport) => {
    location.search = "";
    navigate(location, { replace: true });
    setReportType(type);
  };

  const reportMap = {
    [AdvisorEnums.SalariesReport.GrossSalaries]: <GrossSalaryListView includeSummary={true} />,
    [AdvisorEnums.SalariesReport.SalarySpecifications]: <SalarySpecificationListView />,
  };

  const ReportComponent = reportMap[reportType];

  return (
    <PageLayouts.DashboardLayout<SalaryFormTypes.GrossSalaryFilter>
      entityKey={0}
      hasPermissions={getIsGrossSalaryReportAvailable()}
      title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Salary.Salary)}
      topRightButtons={
        <DashboardButtonGroup
          buttons={(
            EnumHelper.getNumericItemValues(AdvisorEnums.SalariesReport).map((item, index) => (
              <StyledButton
                key={index}
                size="sm"
                onClick={onReportTypeButtonClick.bind(null, item)}
                className={reportType !== index ? cssExports.transparent : ""}
              >
                {LocalizationHelperInstance.getFormattedMessage(`Advisor.SalaryReportType_${index}`)}
              </StyledButton>
            )) as (React.ReactElement | typeof ACTION_SEPARATOR)[]
          ).concat([ACTION_SEPARATOR, <FilterButton />])}
        />
      }
      filterFields={filterFormFields}
      filterQueryStateHandler={filterQueryStateHandler}
      initialFilter={{ year: DateHelper.getYear(DateHelper.today()) }}
    >
      <Grid container item>
        {[ReportComponent]}
      </Grid>
    </PageLayouts.DashboardLayout>
  );
};

export default GrossSalaryReport;
